// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ShaderPresetPreviewContract = contract({
  name: "ShaderPresetPreview",
  description: "Thumbnail-sized preview card for a shader preset. Defaults to a cheap static placeholder until hovered, at which point the live WebGL render kicks in. Use directly when you want a single preset card; use ShaderPresetPicker for a filterable grid.",
  import: "@gradeui/ui",
  aliases: ["shader preview","preset preview","shader card"],
  composesWith: ["ThreeScene (internal)","ShaderPresetPicker (wraps this)"],
  styleDefaults: {"ShaderPresetPreview":"group cursor-pointer flex flex-col gap-2"},
  props: {
  "preset": {
      schema: z.string(),
      design: "content",
      description: "shader preset id from the registry",
  },
  "live": {
      schema: z.enum(["never", "hover", "always"]).optional(),
      design: "knob",
      description: "when to run the live WebGL render",
      default: "hover",
  },
  "postPreset": {
      schema: z.string().optional(),
      design: "content",
      description: "override the preset's default post-FX",
  },
  "palette": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "palette overrides for the preview",
  },
  "aspect": {
      schema: z.enum(["video", "square", "portrait", "wide"]).optional(),
      design: "knob",
      default: "video",
  },
  "hideLabel": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the label strip under the preview",
      default: false,
  },
  "onClick": {
      schema: z.unknown().optional(),
      design: "event",
  },
  },
});
